import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { getTone } from '../../theme/tones';

/**
 * Pastille de statut partagée.
 *
 * Remplace les définitions locales que chaque liste redéfinissait dans son
 * coin. On ne passe plus de couleurs : seulement un TON sémantique
 * (`teal`, `emerald`, `amber`, `rose`, `blue`, `neutral`…), dont les
 * valeurs viennent de `src/theme/tones.js`.
 */
const Pill = ({ icon, label, tone = 'neutral', mono = false, size = 'medium', sx = {}, ...other }) => {
  const t = getTone(tone);
  const compact = size === 'small';

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        px: compact ? 0.8 : 1.1,
        py: compact ? 0.3 : 0.5,
        borderRadius: '9px',
        backgroundColor: t.bg,
        color: t.color,
        border: '1px solid',
        borderColor: t.border,
        fontSize: compact ? '0.66rem' : '0.7rem',
        fontWeight: 700,
        lineHeight: 1.2,
        maxWidth: '100%',
        fontFamily: mono ? '"JetBrains Mono", "Roboto Mono", monospace' : 'inherit',
        letterSpacing: mono ? '0.02em' : 0,
        ...sx
      }}
      {...other}
    >
      {icon}
      <Box
        component="span"
        sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
      >
        {label}
      </Box>
    </Box>
  );
};

Pill.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.node,
  tone: PropTypes.string,
  mono: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
  sx: PropTypes.object
};

export default Pill;
